import { section as SectionData } from "shared/data/section";

export const WidgetPlacement: Record<string, string> = {
  [SectionData.business.entityId]: SectionData.business.name,
  [SectionData.china.entityId]: SectionData.china.name,
  [SectionData.comment.entityId]: SectionData.comment.name,
  [SectionData.economy.entityId]: SectionData.economy.name,
  [SectionData.hongKong.entityId]: SectionData.hongKong.name,
  [SectionData.lifestyle.entityId]: SectionData.lifestyle.name,
  [SectionData.peopleCulture.entityId]: SectionData.peopleCulture.name,
  [SectionData.tech.entityId]: SectionData.tech.name,
  [SectionData.thisWeekInAsia.entityId]: SectionData.thisWeekInAsia.name,
  [SectionData.world.entityId]: SectionData.world.name,
};
